import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { isEmpty } from 'ramda';
import useRoutes from 'src/routes/useRoutes';
import useRedirectAfterLogin from 'src/hooks/useRedirectAfterLogin';
import { selectLoggingOut } from 'src/store/selectors/userInfo';
import { useAuth } from 'react-oidc-context';
export default function AuthCheck({ children, isManagerMode }) {
    const { isAuthenticated, isLoading } = useAuth();
    const noTranslationsLoaded = useSelector((state) => isEmpty(state.translation));
    const loggingOut = useSelector(selectLoggingOut);
    const location = useLocation();
    const { isPathAllowed } = useRoutes();
    const { saveCurrentLocation } = useRedirectAfterLogin();
    if (isAuthenticated || isLoading || noTranslationsLoaded) {
        const isRoot = location.pathname === (isManagerMode ? '/' : '/selfService');
        const isEnabled = isRoot || isPathAllowed(location.pathname);
        return isEnabled ? children : React.createElement(Redirect, { to: isManagerMode ? '/' : '/selfService' });
    }
    else {
        if (!loggingOut) {
            saveCurrentLocation();
        }
        return React.createElement(Redirect, { to: "/login" });
    }
}
